import { AddressFieldHelperText, BoilerFieldDateHelperText, ContactFieldHelperText, OfferFieldHelperText, PaymentBankDetailsHelperText, PaymentTypesHelperText, PlanOptionsFieldHelperText, PropertyFieldHelperText } from "@utils/BasicTypes/enums";
import { LandlordUI, PropertyUI, RelatedUI } from "@utils/ComplexTypes";
import * as UIInterface from "./interface";
export * from "./interface";

const carePlanUIHelperText = (): UIInterface.CarePlanUIHelperText => ({
  CarePlanBillingAddressPropertyHelperText: AddressFieldHelperText.Property,
  CarePlanBillingAddressBusinessNameHelperText: AddressFieldHelperText.BusinessName,
  CarePlanBillingAddressCityHelperText: AddressFieldHelperText.City,
  CarePlanBillingAddressCountryHelperText: AddressFieldHelperText.Country,
  CarePlanBillingAddressLocalityHelperText: AddressFieldHelperText.Locality,
  CarePlanBillingAddressPostcodeHelperText: AddressFieldHelperText.Postcode,
  CarePlanBillingAddressStreetHelperText: AddressFieldHelperText.Street,
  CarePlanBillingContactEmailHelperText: ContactFieldHelperText.Email,
  CarePlanBillingContactFirstNameHelperText: ContactFieldHelperText.FirstName,
  CarePlanBillingContactLandlineHelperText: ContactFieldHelperText.Landline,
  CarePlanBillingContactLastNameHelperText: ContactFieldHelperText.LastName,
  CarePlanBillingContactMobileHelperText: ContactFieldHelperText.Mobile,
  CarePlanBillingContactRelationshipHelperText: null,
  CarePlanBillingContactTitleHelperText: ContactFieldHelperText.Title,
  CarePlanBillingMethodPaymentTypeHelperText: PaymentTypesHelperText.PaymentMethod,
  CarePlanCustomerAddressPropertyHelperText: AddressFieldHelperText.Property,
  CarePlanCustomerAddressBusinessNameHelperText: AddressFieldHelperText.BusinessName,
  CarePlanCustomerAddressCityHelperText: AddressFieldHelperText.City,
  CarePlanCustomerAddressCountryHelperText: AddressFieldHelperText.Country,
  CarePlanCustomerAddressLocalityHelperText: AddressFieldHelperText.Locality,
  CarePlanCustomerAddressPostcodeHelperText: AddressFieldHelperText.Postcode,
  CarePlanCustomerAddressStreetHelperText: AddressFieldHelperText.Street,
  CarePlanCustomerContactEmailHelperText: ContactFieldHelperText.Email,
  CarePlanCustomerContactFirstNameHelperText: ContactFieldHelperText.FirstName,
  CarePlanCustomerContactLandlineHelperText: ContactFieldHelperText.Landline,
  CarePlanCustomerContactLastNameHelperText: ContactFieldHelperText.LastName,
  CarePlanCustomerContactMobileHelperText: ContactFieldHelperText.Mobile,
  CarePlanCustomerContactRelationshipHelperText: null,
  CarePlanCustomerContactTitleHelperText: ContactFieldHelperText.Title,
  CarePlanPaymentBankDetailsAccountNumberHelperText: PaymentBankDetailsHelperText.AccountCode,
  CarePlanPaymentBankDetailsBankNameHelperText: PaymentBankDetailsHelperText.BankName,
  CarePlanPaymentBankDetailsSortCodeHelperText: PaymentBankDetailsHelperText.SortCode,
  CarePlanPlanDetailsAddressPropertyHelperText: AddressFieldHelperText.Property,
  CarePlanPlanDetailsAddressBusinessNameHelperText: AddressFieldHelperText.BusinessName,
  CarePlanPlanDetailsAddressCityHelperText: AddressFieldHelperText.City,
  CarePlanPlanDetailsAddressCountryHelperText: AddressFieldHelperText.Country,
  CarePlanPlanDetailsAddressLocalityHelperText: AddressFieldHelperText.Locality,
  CarePlanPlanDetailsAddressPostcodeHelperText: AddressFieldHelperText.Postcode,
  CarePlanPlanDetailsAddressStreetHelperText: AddressFieldHelperText.Street,
  CarePlanPlanDetailsBoilerBoilerInstallationDateHelperText: BoilerFieldDateHelperText.BoilerInstallationDate,
  CarePlanPlanDetailsBoilerBoilerLastServicedDateHelperText: BoilerFieldDateHelperText.BoilerLastServicedDate,
  CarePlanPlanDetailsBoilerBoilerManufacturersHelperText: BoilerFieldDateHelperText.BoilerManufacturers,
  CarePlanPlanDetailsBoilerBoilerModelHelperText: BoilerFieldDateHelperText.BoilerModel,
  CarePlanPlanDetailsBoilerHeatingTypesHelperText: BoilerFieldDateHelperText.HeatingTypes,
  CarePlanPlanDetailsOfferOfferReasonHelperText: OfferFieldHelperText.OfferReason,
  CarePlanPlanDetailsOfferOfferTypeHelperText: OfferFieldHelperText.OfferType,
  CarePlanPlanDetailsPlanOptionsBillingFrequencyHelperText: PlanOptionsFieldHelperText.BillingFrequency,
  CarePlanPlanDetailsPlanOptionsDurationHelperText: PlanOptionsFieldHelperText.Duration,
  CarePlanPlanDetailsPlanOptionsExcessHelperText: PlanOptionsFieldHelperText.Excess,
  CarePlanPlanDetailsPlanOptionsPlanTypeHelperText: PlanOptionsFieldHelperText.PlanType,
  CarePlanPlanDetailsPropertyBathroomsHelperText: PropertyFieldHelperText.Bathrooms,
  CarePlanPlanDetailsPropertyBedroomsHelperText: PropertyFieldHelperText.Bedrooms,
  CarePlanPlanDetailsPropertyBuildingTypesHelperText: PropertyFieldHelperText.BuildingTypes,
  CarePlanPlanDetailsPropertyExternalDoorsHelperText: PropertyFieldHelperText.ExternalDoors,
  CarePlanPlanDetailsPropertyGasAppliancesHelperText: PropertyFieldHelperText.GasAppliances,
  CarePlanPlanDetailsPropertyGasSafetyDueDateHelperText: PropertyFieldHelperText.GasSafetyDueDate,
  CarePlanPlanDetailsPropertyRadiatorsHelperText: PropertyFieldHelperText.Radiators,
  CarePlanPlanDetailsOfferPromoCodeHelperText: OfferFieldHelperText.PromoCode,
});

const carePlanUI = (): UIInterface.CarePlanUI => ({
  CarePlanBillingAddressAsProperty: false,
  CarePlanBillingAddressProperty: "",
  CarePlanBillingAddressBusinessName: "",
  CarePlanBillingAddressCity: "",
  CarePlanBillingAddressCountry: "United Kingdom",
  CarePlanBillingAddressIsBusiness: false,
  CarePlanBillingAddressLocality: "",
  CarePlanBillingAddressModalOpen: false,
  CarePlanBillingAddressPostcode: "",
  CarePlanBillingAddressSelectedAddress: undefined,
  CarePlanBillingAddressStreet: "",
  CarePlanBillingContactAsContact: false,
  CarePlanBillingContactEmail: "",
  CarePlanBillingContactFirstName: "",
  CarePlanBillingContactLandline: "",
  CarePlanBillingContactLastName: "",
  CarePlanBillingContactMobile: "",
  CarePlanBillingContactModalOpen: false,
  CarePlanBillingContactRelationship: null,
  CarePlanBillingContactSelectedContact: undefined,
  CarePlanBillingContactTitle: undefined,
  CarePlanBillingMethodPaymentType: null,
  CarePlanCustomerAddressAsProperty: false,
  CarePlanCustomerAddressProperty: "",
  CarePlanCustomerAddressBusinessName: "",
  CarePlanCustomerAddressCity: "",
  CarePlanCustomerAddressCountry: "United Kingdom",
  CarePlanCustomerAddressIsBusiness: false,
  CarePlanCustomerAddressLocality: "",
  CarePlanCustomerAddressModalOpen: false,
  CarePlanCustomerAddressPostcode: "",
  CarePlanCustomerAddressSelectedAddress: undefined,
  CarePlanCustomerAddressStreet: "",
  CarePlanCustomerContactAsContact: false,
  CarePlanCustomerContactEmail: "",
  CarePlanCustomerContactFirstName: "",
  CarePlanCustomerContactLandline: "",
  CarePlanCustomerContactLastName: "",
  CarePlanCustomerContactMobile: "",
  CarePlanCustomerContactModalOpen: false,
  CarePlanCustomerContactRelationship: null,
  CarePlanCustomerContactSelectedContact: undefined,
  CarePlanCustomerContactTitle: undefined,
  CarePlanPaymentBankDetailsAccountNumber: "",
  CarePlanPaymentBankDetailsBranchName: "",
  CarePlanPaymentBankDetailsSortCode: "",
  CarePlanPlanDetailsAddressAsProperty: false,
  CarePlanPlanDetailsAddressProperty: "",
  CarePlanPlanDetailsAddressBusinessName: "",
  CarePlanPlanDetailsAddressCity: "",
  CarePlanPlanDetailsAddressCountry: "United Kingdom",
  CarePlanPlanDetailsAddressIsBusiness: false,
  CarePlanPlanDetailsAddressLocality: "",
  CarePlanPlanDetailsAddressModalOpen: false,
  CarePlanPlanDetailsAddressPostcode: "",
  CarePlanPlanDetailsAddressSelectedAddress: undefined,
  CarePlanPlanDetailsAddressStreet: "",
  CarePlanPlanDetailsBoilerBoilerInstallationDate: undefined,
  CarePlanPlanDetailsBoilerBoilerLastServicedDate: undefined,
  CarePlanPlanDetailsBoilerBoilerManufacturers: undefined,
  CarePlanPlanDetailsBoilerBoilerModel: "",
  CarePlanPlanDetailsOfferOfferReason: undefined,
  CarePlanPlanDetailsOfferOfferType: undefined,
  CarePlanPlanDetailsPlanOptionsBillingFrequency: undefined,
  CarePlanPlanDetailsPlanOptionsComments: "",
  CarePlanPlanDetailsPlanOptionsDuration: undefined,
  CarePlanPlanDetailsPlanOptionsExcess: undefined,
  CarePlanPlanDetailsPlanOptionsPlanType: undefined,
  CarePlanPlanDetailsPropertyBathrooms: -1,
  CarePlanPlanDetailsPropertyBedrooms: -1,
  CarePlanPlanDetailsPropertyBuildingTypes: undefined,
  CarePlanPlanDetailsPropertyExclusionDetails: "",
  CarePlanPlanDetailsPropertyExternalDoors: -1,
  CarePlanPlanDetailsPropertyGasAppliances: -1,
  CarePlanPlanDetailsPropertyGasSafetyDueDate: undefined,
  CarePlanPlanDetailsPropertyRadiators: -1,
  CarePlanPaymentBankDetailsBankName: "",
  CarePlanPaymentBankDetailsTitle: "",
  CarePlanPlanDetailsOfferPromoCode: "",
});

const landlordUI = (): LandlordUI => ({
  LandlordAddressAsProperty: false,
  LandlordAddressProperty: "",
  LandlordAddressBusinessName: "",
  LandlordAddressCity: "",
  LandlordAddressCountry: "United Kingdom",
  LandlordAddressIsBusiness: false,
  LandlordAddressLocality: "",
  LandlordAddressModalOpen: false,
  LandlordAddressPostcode: "",
  LandlordAddressSelectedAddress: undefined,
  LandlordAddressStreet: "",
  LandlordAddressPropertyHelperText: AddressFieldHelperText.Property,
  LandlordAddressBusinessNameHelperText: AddressFieldHelperText.BusinessName,
  LandlordAddressCityHelperText: AddressFieldHelperText.City,
  LandlordAddressCountryHelperText: AddressFieldHelperText.Country,
  LandlordAddressLocalityHelperText: AddressFieldHelperText.Locality,
  LandlordAddressPostcodeHelperText: AddressFieldHelperText.Postcode,
  LandlordAddressStreetHelperText: AddressFieldHelperText.Street,
  LandlordContactAsContact: false,
  LandlordContactEmail: "",
  LandlordContactFirstName: "",
  LandlordContactLandline: "",
  LandlordContactLastName: "",
  LandlordContactMobile: "",
  LandlordContactModalOpen: false,
  LandlordContactRelationship: null,
  LandlordContactSelectedContact: undefined,
  LandlordContactTitle: undefined,
  LandlordContactEmailHelperText: ContactFieldHelperText.Email,
  LandlordContactFirstNameHelperText: ContactFieldHelperText.FirstName,
  LandlordContactLandlineHelperText: ContactFieldHelperText.Landline,
  LandlordContactLastNameHelperText: ContactFieldHelperText.LastName,
  LandlordContactMobileHelperText: ContactFieldHelperText.Mobile,
  LandlordContactRelationshipHelperText: null,
  LandlordContactTitleHelperText: ContactFieldHelperText.Title,
});

const relatedUI = (): RelatedUI => ({
  RelatedAddressAsProperty: false,
  RelatedAddressProperty: "",
  RelatedAddressBusinessName: "",
  RelatedAddressCity: "",
  RelatedAddressCountry: "",
  RelatedAddressIsBusiness: false,
  RelatedAddressLocality: "",
  RelatedAddressModalOpen: false,
  RelatedAddressPostcode: "",
  RelatedAddressSelectedAddress: undefined,
  RelatedAddressStreet: "",
  RelatedAddressPropertyHelperText: AddressFieldHelperText.Property,
  RelatedAddressBusinessNameHelperText: AddressFieldHelperText.BusinessName,
  RelatedAddressCityHelperText: AddressFieldHelperText.City,
  RelatedAddressCountryHelperText: AddressFieldHelperText.Country,
  RelatedAddressLocalityHelperText: AddressFieldHelperText.Locality,
  RelatedAddressPostcodeHelperText: AddressFieldHelperText.Postcode,
  RelatedAddressStreetHelperText: AddressFieldHelperText.Street,
  RelatedContactAsContact: false,
  RelatedContactEmail: "",
  RelatedContactFirstName: "",
  RelatedContactLandline: "",
  RelatedContactLastName: "",
  RelatedContactMobile: "",
  RelatedContactModalOpen: false,
  RelatedContactRelationship: "",
  RelatedContactSelectedContact: undefined,
  RelatedContactTitle: undefined,
  RelatedContactEmailHelperText: ContactFieldHelperText.Email,
  RelatedContactFirstNameHelperText: ContactFieldHelperText.FirstName,
  RelatedContactLandlineHelperText: ContactFieldHelperText.Landline,
  RelatedContactLastNameHelperText: ContactFieldHelperText.LastName,
  RelatedContactMobileHelperText: ContactFieldHelperText.Mobile,
  RelatedContactRelationshipHelperText: ContactFieldHelperText.Relationship,
  RelatedContactTitleHelperText: ContactFieldHelperText.Title,
});

const propertyUI = (): PropertyUI => ({
  PropertyAddressAsProperty: false,
  PropertyAddressProperty: "",
  PropertyAddressBusinessName: "",
  PropertyAddressCity: "",
  PropertyAddressCountry: "United Kingdom",
  PropertyAddressIsBusiness: false,
  PropertyAddressLocality: "",
  PropertyAddressModalOpen: false,
  PropertyAddressPostcode: "",
  PropertyAddressSelectedAddress: undefined,
  PropertyAddressStreet: "",
  PropertyAddressPropertyHelperText: AddressFieldHelperText.Property,
  PropertyAddressBusinessNameHelperText: AddressFieldHelperText.BusinessName,
  PropertyAddressCityHelperText: AddressFieldHelperText.City,
  PropertyAddressCountryHelperText: AddressFieldHelperText.Country,
  PropertyAddressLocalityHelperText: AddressFieldHelperText.Locality,
  PropertyAddressPostcodeHelperText: AddressFieldHelperText.Postcode,
  PropertyAddressStreetHelperText: AddressFieldHelperText.Street,
  PropertyContactAsContact: false,
  PropertyContactEmail: "",
  PropertyContactFirstName: "",
  PropertyContactLandline: "",
  PropertyContactLastName: "",
  PropertyContactMobile: "",
  PropertyContactModalOpen: false,
  PropertyContactRelationship: null,
  PropertyContactSelectedContact: undefined,
  PropertyContactTitle: undefined,
  PropertyContactEmailHelperText: ContactFieldHelperText.Email,
  PropertyContactFirstNameHelperText: ContactFieldHelperText.FirstName,
  PropertyContactLandlineHelperText: ContactFieldHelperText.Landline,
  PropertyContactLastNameHelperText: ContactFieldHelperText.LastName,
  PropertyContactMobileHelperText: ContactFieldHelperText.Mobile,
  PropertyContactRelationshipHelperText: null,
  PropertyContactTitleHelperText: ContactFieldHelperText.Title,
  PropertyContactIsLandlord: false,
  PropertyContactIsOther: false,
  PropertyContactIsTenant: false,
});

const bookingUI = (): UIInterface.Booking => ({
  BookingCardSecured: false,
  BookingCompletionMsg: "",
  BookingParkingAvailability: false,
  BookingParkingComments: "",
  BookingParkingLocation: "",
  BookingPaymentActiveTab: 0,
  BookingPaymentIsBooked: false,
  BookingPaymentTab: 0,
  BookingPaymentTabsList: [
    {
      label: "Payment Details",
      name: "billing-details",
    },
    {
      label: "Booking",
      name: "booking",
    },
  ],
  BookingRejectionReason: null,
  BookingPaymentAddressAsProperty: false,
  BookingPaymentAddressProperty: "",
  BookingPaymentAddressBusinessName: "",
  BookingPaymentAddressCity: "",
  BookingPaymentAddressCountry: "United Kingdom",
  BookingPaymentAddressIsBusiness: false,
  BookingPaymentAddressLocality: "",
  BookingPaymentAddressModalOpen: false,
  BookingPaymentAddressPostcode: "",
  BookingPaymentAddressSelectedAddress: undefined,
  BookingPaymentAddressStreet: "",
  BookingPaymentContactAsContact: false,
  BookingPaymentContactEmail: "",
  BookingPaymentContactFirstName: "",
  BookingPaymentContactLandline: "",
  BookingPaymentContactLastName: "",
  BookingPaymentContactMobile: "",
  BookingPaymentContactModalOpen: false,
  BookingPaymentContactRelationship: null,
  BookingPaymentContactSelectedContact: undefined,
  BookingPaymentContactTitle: undefined,
  BookingPaymentAddressPropertyHelperText: AddressFieldHelperText.Property,
  BookingPaymentAddressBusinessNameHelperText: AddressFieldHelperText.BusinessName,
  BookingPaymentAddressCityHelperText: AddressFieldHelperText.City,
  BookingPaymentAddressCountryHelperText: AddressFieldHelperText.Country,
  BookingPaymentAddressLocalityHelperText: AddressFieldHelperText.Locality,
  BookingPaymentAddressPostcodeHelperText: AddressFieldHelperText.Postcode,
  BookingPaymentAddressStreetHelperText: AddressFieldHelperText.Street,
  BookingPaymentContactEmailHelperText: ContactFieldHelperText.Email,
  BookingPaymentContactFirstNameHelperText: ContactFieldHelperText.FirstName,
  BookingPaymentContactLandlineHelperText: ContactFieldHelperText.Landline,
  BookingPaymentContactLastNameHelperText: ContactFieldHelperText.LastName,
  BookingPaymentContactMobileHelperText: ContactFieldHelperText.Mobile,
  BookingPaymentContactRelationshipHelperText: null,
  BookingPaymentContactTitleHelperText: ContactFieldHelperText.Title,
  BookingPaymentMethodCardSecured: false,
  BookingPaymentMethodCompanyRegistration: "",
  BookingPaymentMethodPaymentMethods: null,
  BookingPaymentMethodActiveSideTab: 0,
  BookingPaymentMethodCompletionMsg: "",
  BookingPaymentMethodIsBooked: false,
  BookingPaymentMethodCardAgreed: false,
  BookingPaymentMethodParkingAvailability: false,
  BookingPaymentMethodParkingComments: "",
  BookingPaymentMethodParkingLocation: "",
  BookingPaymentMethodPaymentRequisitions: null,
  BookingPaymentMethodRejectionReason: null,
  BookingPaymentMethodTab: 0,
  BookingPaymentMethodPaymentMethodsHelperText: PaymentTypesHelperText.PaymentMethod,
  BookingPaymentMethodPaymentRequisitionsHelperText: PaymentTypesHelperText.Requisition,
  BookingPaymentMethodCompanyRegistrationHelperText: PaymentTypesHelperText.Registration,
});

export const uiTemplate: UIInterface.TemplateUI = () => ({
  ActiveStep: 0,
  AddressToMatch: "",
  AgentsModal: false,
  AppointmentDate: undefined,
  AppointmentGeneralNotes: "",
  AppointmentParkingAvailable: null,
  AppointmentParkingNotes: null,
  AppointmentRadios: {
    am: true,
    eve: true,
    pm: true,
  },
  AppointmentTime: null,
  ApprovalNeeded: false,
  BookingId: 0,
  ...bookingUI(),
  CadentModal: false,
  CallAlert: {
    campaign: "",
    complete: false,
    from: "",
    severity: "success",
    show: false,
    to: "",
  },
  CallCampaign: "",
  CallerInfo: "",
  CallerName: "",
  CallFrom: "",
  CallInfo: "",
  CallMeBackAuthDialogModal: false,
  CallMeBackAuthValue: "",
  CallMeBacksModal: false,
  CallMeBacksModalData: {},
  CallMeBacksQueue: [],
  CallTo: "",
  CarePlanSummary: "",
  CarePlanActiveTab: 0,
  CarePlanBillingActiveSideTab: 0,
  CarePlanBillingIsHouse: false,
  CarePlanCustomerActiveSideTab: 0,
  CarePlanCustomerIsHouse: false,
  CarePlanDeclinedReason: null,
  CarePlanOffered: false,
  CarePlanPaymentActiveSideTab: 0,
  CarePlanPaymentDirectDebitModal: false,
  CarePlanPlanDetailsActiveSideTab: 0,
  CarePlanPlanDetailsIsBoiler: false,
  CarePlanPlanDetailsIsBusiness: false,
  CarePlanPlanDetailsIsHouse: false,
  CarePlanPlanDetailsIsLandlord: false,
  CarePlanReference: "",
  ServiceAgreementPolicyModal: false,
  CarePlanTabsList: [
    {
      label: "Plan Details",
      name: "plan",
    },
    {
      label: "Customer",
      name: "customer",
    },
    {
      label: "Billing Details",
      name: "billing",
    },
    {
      label: "Payment",
      name: "subscription",
    },
  ],
  Charge: 0,
  ComboAgent: undefined,
  CompaniesHouseRecordDialog: false,
  ContactModalOpen: false,
  CustomerNameInputModal: false,
  CustomerType: "home-owner",
  DevFrom: "",
  DevSimulate: false,
  DevTo: "",
  Done: false,
  FailDialogModal: false,
  FailFeedbackDialogModal: false,
  FailFeedbackReason: undefined,
  FailFeedbackApplianceIssue: false,
  FailFeedbackValue: "",
  FinalDialogModal: false,
  FollowDateTime: undefined,
  FollowUpDateTime: undefined,
  FollowUpDialogModal: false,
  FollowUpValue: "",
  GenericPopupModal: false,
  IsHouse: false,
  JobCoverage: undefined,
  JobHistoryModal: false,
  JobSearchModal: false,
  JobsSearchTerm: "",
  ...landlordUI(),
  ...propertyUI(),
  LastJobModal: false,
  Loading: false,
  MainMenuModal: false,
  NewBookingDialogModal: false,
  OkToSendCommunication: false,
  ProblemActiveAddressTab: 0,
  ProblemActiveContactTab: 0,
  ProblemAddressString: "",
  ProblemCategories: [],
  ProblemComboCategory: null,
  ProblemComboJob: null,
  ProblemComboJobSearch: null,
  ProblemComboTrade: null,
  ProblemGroups: null,
  ProblemGroupsOptions: null,
  ProblemInputPostcode: "",
  ProblemJob: null,
  ProblemJobs: [],
  ProblemJobsOptions: [],
  ProblemMsg: "",
  ProblemMsgShow: false,
  ProblemMsgVariant: "success",
  ProblemPastJobsShow: false,
  ProblemSearch: "",
  ProblemShowMsg: false,
  ProblemTabsList: JSON.stringify([
    {
      label: "Property",
      name: "property",
    },
  ]),
  ProblemTradeGroups: null,
  ProblemTrades: null,
  ProblemTradesOptions: null,
  PromoCode: "",
  PromoDiscount: 0,
  PropertyAddressModalOpen: false,
  PropertyAsContact: false,
  PropertyAsProperty: false,
  PropertyProperty: "",
  PropertyPropertyHelperText: "Please enter a valid property",
  PropertyBusinessName: "",
  PropertyBusinessNameHelperText: "Please enter a valid business name",
  PropertyCity: "",
  PropertyCityHelperText: "Please enter a valid city",
  PropertyContactModalOpen: false,
  PropertyCountry: "United Kingdom",
  PropertyCountryHelperText: "Please enter a valid country",
  PropertyEmail: "",
  PropertyEmailHelperText: "Please enter a valid email",
  PropertyFirstName: "",
  PropertyFirstNameHelperText: "Please enter a valid first name",
  PropertyIsBusiness: false,
  PropertyIsLandlord: false,
  PropertyIsOther: false,
  PropertyIsTenant: false,
  PropertyLandline: "",
  PropertyLandlineHelperText: "Please enter a valid landline number",
  PropertyLastName: "",
  PropertyLastNameHelperText: "Please enter a valid last name",
  PropertyLocality: "",
  PropertyLocalityHelperText: "Please enter a valid locality",
  PropertyMobile: "",
  PropertyMobileHelperText: "Please enter a valid mobile number",
  PropertyPostcode: "",
  PropertyPostcodeHelperText: "Please enter a valid postcode",
  PropertyRelationship: null,
  PropertyRelationshipHelperText: null,
  PropertySelectedAddress: undefined,
  PropertySelectedContact: undefined,
  PropertyStreet: "",
  PropertyStreetHelperText: "Please enter a valid street",
  PropertyTitle: null,
  PropertyTitleHelperText: "Please select a valid title",
  RatesActiveTab: 0,
  RatesDiscount: 0,
  RatesRateReason: undefined,
  RatesTabsList: [
    {
      label: "Benefits",
      name: "benefits",
    },
    {
      label: "Rate Reductions",
      name: "ratereductions",
    },
  ],
  ...carePlanUIHelperText(),
  ...carePlanUI(),
  ...relatedUI(),
  RateText: "",
  RequiredModal: false,
  SquareCard: null,
  SquareCardBrand: "",
  SquareCardData: null,
  SquareCardString: "",
  SquareCustomerId: null,
  SquareDisabled: true,
  SquareEnableVerifyBuyer: false,
  SquareError: null,
  SquareFocus: "cardNumber",
  SquareFormLoaded: false,
  SquareInfo: "Please enter card details and press STORE.",
  SquareLoaded: false,
  SquareNonce: null,
  SquarePaymentData: null,
  SquarePaymentForm: null,
  SquareProcessing: false,
  SquareResetEnabled: false,
  SquareSucceeded: false,
  SquareUserChallenged: undefined,
  SquareVerification: null,
  Stage1Complete: false,
  Stage2Complete: false,
  Stage3Complete: false,
  Stage4Complete: false,
  StepThreeActiveTab: "charge rate",
  StepTwoActiveTab: "date",
  TimeFrame: {
    label: "3 Months",
    value: 24 * 90,
  },
});
